import { ImportantWord } from "./components/about-page/about-page.styles"
import { BlogSectionSpacer } from "./components/blog/blog.style"

import Stitched from "../src/assets/blogs/stitcher/stitched.png"
import NotStitched from "../src/assets/blogs/stitcher/non-stitched.png"
import StitcherImage from "../src/assets/blogs/stitcher/image.png"

import CRWN from '../src/assets/projects/CRWN.png'

export const blogs = [
    {
        id: "tile-stitcher",
        title: <>How to seemlesly continue <ImportantWord>rule tiles</ImportantWord> on <ImportantWord>multiple tilemaps</ImportantWord> in <ImportantWord>Godot</ImportantWord></>,
        image: StitcherImage,
        body: <>
        <h1>Overview</h1>

        When I first started building a chunk-based world system for my commercial game, Agronauts, in Godot, I ran into a problem that a lot of tile-based games face: seams. <br /><br />

        Each chunk in my world had its own TileMap, and while that made sense from a technical standpoint, visually it created some ugly results. The edges of chunks didn’t line up perfectly, and whenever two chunks touched, there would be a harsh line where tiles didn’t blend. Imagine exploring a continuous world but constantly seeing jagged cracks running through the landscape—definitely not the immersive vibe I was going for.<br /><br />

        <img src={NotStitched} /><br />

        At first, I thought about brute-forcing a fix—maybe merging TileMaps together or manually adjusting borders—but that would have been messy and inefficient. I wanted a smarter, reusable solution. That’s when I came up with what I now call my Tile Stitcher system.<br /><br />


        <BlogSectionSpacer />
        <h1>How the Tile Stitcher Works</h1>

        The idea behind the Tile Stitcher is pretty straightforward: instead of forcing chunks to magically align, I add an overlay layer that smooths out their borders. Here’s the breakdown of how it works:<br /><br />

        <li>Check the borders – For every tile that sits on the edge of a chunk, the stitcher looks at its neighboring tiles (in adjacent chunks).</li><br />

        <li>Generate a bitmask – Based on which neighbors exist, it creates a bitmask. Think of it like a binary “map” of whether there’s a tile on each side.</li><br />

        <li>Pick the right border tile – Using that bitmask, it selects the correct transition tile from a dedicated border tile atlas.</li><br />

        <li>Place it in an overlay – These “stitched” tiles don’t overwrite the chunk. Instead, they go into a separate overlay TileMap that sits on top, purely for smoothing out the seams.</li><br />


        <BlogSectionSpacer />
        <h1>The Results</h1>

        Once I set this up, the difference was night and day. The world went from being a patchwork of disconnected chunks to looking like one continuous map. The ugly seams disappeared, and I could finally pan across the world without being distracted by the technical limitations underneath.<br /><br />

        <img src={Stitched}/><br />

        What I really like about this approach is that it scales. No matter how many chunks I generate, the stitcher automatically handles their borders. I don’t need to worry about manual clean-up or tile misalignment anymore.<br /><br />


        <BlogSectionSpacer />
        <h1>Why This Matters</h1>

        If you’re building a game with multiple TileMaps—whether that’s for chunks, biomes, or layered systems—you’re probably going to run into visual seams at some point. A dynamic, bitmask-based border layer like this can save you a lot of time and frustration.<br /><br />

        Instead of treating seams as a painful technical problem, you can design around them and even make the system reusable for future projects. Personally, I find that these little behind-the-scenes tools are what make development smoother in the long run.<br /><br />

        That’s how I solved one of the most frustrating parts of chunk-based TileMaps in Godot. Hopefully this breakdown gives you some ideas for your own projects.<br /><br />

        Have you run into similar issues in your game dev work? I’d love to hear what solutions you came up with!<br /><br />
        </> ,
        readtime: 2
    },
    {
        id: "crwn-clothing-testing",
        title: <>How I Made My <ImportantWord>Solo</ImportantWord> E-Commerce Project <ImportantWord>Bug-Free</ImportantWord> with <ImportantWord>Playwright</ImportantWord></>,
        image: CRWN,
        body: 
        <>
            <h1>Overview</h1>

            When I built CRWN Clothing, a simple e-commerce side project in React, I wanted it to feel polished—even though it was just a solo project. I knew unit tests could catch component-level issues, but I was more concerned about the user experience across the whole site: adding items to the cart, checking out, and navigating between pages. That’s when I decided to try Playwright for end-to-end testing.<br /><br />


            <BlogSectionSpacer />
            <h1>Why Playwright for a Solo Project?</h1>

            At first, I hesitated. “It’s just me; do I really need E2E tests?” But after a few days of manually clicking through flows, I realized that even small changes could break something unintentionally. Playwright offered a simple way to simulate real user behavior and catch bugs before they became frustrating.<br /><br />

            The biggest advantage for me was automation: I could run the same flows repeatedly without touching the UI, which saved time and helped me focus on building new features rather than manually testing old ones.<br /><br />


            <BlogSectionSpacer />
            <h1>Catching Cart Bugs Early</h1>

            When I was building CRWN Clothing, I wanted the add-to-cart and discount code functionality to work flawlessly. On the surface, the flow was simple: select a product, choose a size and quantity, add it to the cart, and apply a discount code.<br /><br />

            But when I ran my first Playwright test, it immediately caught a subtle bug. Sometimes, if you added multiple items and applied a discount code, the total wouldn’t update correctly. For example, a 10% discount might only apply to one item instead of all products in the cart.<br /><br />

            It was the kind of bug that could confuse users and ruin the shopping experience. Catching it within minutes with Playwright saved me hours of manual testing and ensured the cart totals were always accurate.<br /><br />


            <BlogSectionSpacer />
            <h1>Testing the Checkout Flow</h1>
            After fixing the cart bug, I used Playwright to test the checkout process. I went through the full user flow: filling out the forms, entering payment details, and submitting an order.<br /><br />

            Everything worked perfectly. There were no bugs, and I could confidently say that the checkout process was smooth and reliable. Running these tests gave me peace of mind that my app’s core functionality was solid, even as a solo developer.<br /><br />


            <BlogSectionSpacer />
            <h1>What I Learned</h1>

            E2E testing isn’t just for big teams; even solo projects benefit from it. Playwright makes tests feel close to real user interactions, with automatic waits and network handling.Writing a few core flows is enough; you don’t need to test every tiny component.<br /><br />


            <BlogSectionSpacer />
            <h1>Why I’ll Keep Using It</h1>

            After adding Playwright to CRWN Clothing, I could iterate faster and feel confident that changes wouldn’t break basic flows. For a side project, it was an unexpectedly powerful tool that made the app feel production-ready—even though it was just me working on it.<br /><br />
        </>,
        readtime: 3
    },
]